'use strict';

function pushHistoryState(path) {
  history.pushState({href: path}, '', path);
}

function replaceHistoryState(path) {
  history.replaceState({href: path}, '', path);
}

function setupPopStateService(Router) {
  window.addEventListener('popstate', (e) => {
    if (e.state != null) {
      if (e.state.href !== null) Router.navigatePopState(e.state.href);
    }
  });
}

module.exports = {
  pushHistoryState,
  setupPopStateService,
  replaceHistoryState
}



// WEBPACK FOOTER //
// ../autor/src/state.js